export default __webpack_public_path__ + "static/media/intergreens-logo.1760dca8.png";